import { useSelector } from 'react-redux';

import { aiChatbot } from '../constants/featureFlag';
import { useFeatureFlag } from './useFeatureFlag';
import { jsonStringToObject } from '../utils/common';

export function useAiChatbotPermission() {
  const currentUser = useSelector((state) => state.role.user);
  const aiChatbotAllowedEmails = useFeatureFlag(aiChatbot, JSON.stringify([]));

  const authorizedEmails = jsonStringToObject(aiChatbotAllowedEmails, []);
  const userEmail = currentUser?.email;
  const isAllowedAiChatbot = userEmail && Array.isArray(authorizedEmails) && authorizedEmails.includes(userEmail);

  return {
    isAllowedAiChatbot: isAllowedAiChatbot,
  };
}
